import { render } from "./cameraClosedBig.vue?vue&type=template&id=ca5a21e8"
const script = {}

import exportComponent from "D:\\wamp\\www\\ycjx\\chat-example\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__